import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@sentinel/api-client';
import { type Branding, DEFAULT_BRANDING } from '@sentinel/ui';
import { useApi } from '../../lib/api';

export interface BrandingQueryResult {
  data: Branding;
  isLoading: boolean;
  isError: boolean;
}

export function useBrandingQuery(tenantId?: string): BrandingQueryResult {
  const api = useApi();
  const enabled = Boolean(tenantId);
  const query = useQuery({
    queryKey: queryKeys.branding(tenantId),
    enabled,
    queryFn: async () => {
      const { data, error } = await api.GET('/auth/branding', {
        params: { query: { tenant_id: tenantId! } },
      });
      if (error) throw error;
      return mapBranding(data);
    },
    staleTime: 5 * 60_000,
  });

  if (!enabled) return { data: DEFAULT_BRANDING, isLoading: false, isError: false };
  return {
    data: query.data ?? DEFAULT_BRANDING,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export function mapBranding(r: {
  display_name?: string | null;
  logo_url?: string | null;
  primary_color?: string | null;
}): Branding {
  return {
    productName: r.display_name ?? DEFAULT_BRANDING.productName,
    logoUrl: r.logo_url ?? null,
    primaryColor: r.primary_color ?? DEFAULT_BRANDING.primaryColor,
  };
}
